import React from "react";
import styled from "styled-components";
import {
	Frame,
	Close,
	Item,
	Label,
	List,
	Title,
	CloseIcon,
	BottomBar,
	ToCorporate,
	NewTabIcon,
	BottomLabel,
} from "./styles";

interface Props {
	navInfo: {
		label: string;
		href: string;
	}[];
	handleNavigation: (event: React.MouseEvent<HTMLAnchorElement>) => void;
	closeMenu: () => void;
	className?: string;
}

const SpMenu: React.FC<Props> = (props) => {
	const { navInfo, handleNavigation, closeMenu, className } = props;
	return (
		<Frame className={className}>
			<Title>INDEX</Title>
			<List>
				{navInfo.map((val, index) => (
					<Item key={index} href={val.href} onClick={handleNavigation}>
						<Label>{val.label}</Label>
						<svg xmlns="http://www.w3.org/2000/svg" width="8" height="12">
							<path
								d="M 1 1 L 6 6 L 1 11"
								fill="transparent"
								strokeWidth="2"
								stroke="rgb(26, 48, 128)"
							></path>
						</svg>
					</Item>
				))}
			</List>
			<BottomBar>
				<ToCorporate href="http://ns-co.com/" target="blank">
					<NewTabIcon width="17" height="13">
						<path
							d="M 1 4 L 13 4 L 13 12 L 1 12 Z"
							fill="hsl(0, 0%, 100%)"
							strokeWidth="2"
							stroke="rgb(26, 48, 128)"
						></path>
						<path
							d="M 4 1 L 16 1 L 16 9 L 4 9 Z"
							fill="hsl(0, 0%, 100%)"
							strokeWidth="2"
							stroke="rgb(26, 48, 128)"
						></path>
					</NewTabIcon>
					<BottomLabel>企業サイト</BottomLabel>
				</ToCorporate>
				<Close onClick={closeMenu}>
					<CloseIcon />
					<BottomLabel>閉じる</BottomLabel>
				</Close>
			</BottomBar>
		</Frame>
	);
};

export default styled(SpMenu)``;
